// veh_type_group_code/VehTypeGroupCodeGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * VEH_TYPE_GROUP_CODE Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-22 10:22:04 using DbdbTap
 ************************************************ */

const VEH_TYPE_GROUP_CODE_LIST_PART = gql`
fragment VehTypeGroupCodeListPart on VehTypeGroupCode {
    vehTypeGpCd
    groupName
    memo
    regDate
    regUser
    userName
}
`;


export const LIST_VEH_TYPE_GROUP_CODE = gql`
${VEH_TYPE_GROUP_CODE_LIST_PART}
query ListVehTypeGroupCode {
    vehTypeGroupCodeList {
        ...VehTypeGroupCodeListPart
    }
}
`;

export const GET_VEH_TYPE_GROUP_CODE = gql`
${VEH_TYPE_GROUP_CODE_LIST_PART}
query GetVehTypeGroupCode($vehTypeGpCd:String!) {
    vehTypeGroupCodeItem(vehTypeGpCd:$vehTypeGpCd) {
        ...VehTypeGroupCodeListPart
    }
}
`;

export const ADD_VEH_TYPE_GROUP_CODE = gql`
mutation AddVehTypeGroupCode($vehTypeGroupCode:InputVehTypeGroupCodeAdd!) {
	vehTypeGroupCodeAdd(vehTypeGroupCode: $vehTypeGroupCode) {
		ok
		message
	}
}
`;

export const EDIT_VEH_TYPE_GROUP_CODE = gql`
mutation EditVehTypeGroupCode($vehTypeGroupCode:InputVehTypeGroupCodeEdit!) {
	vehTypeGroupCodeEdit(vehTypeGroupCode: $vehTypeGroupCode) {
		ok
		message
	}
}
`;

export const REMOVE_VEH_TYPE_GROUP_CODE = gql`
mutation RemoveVehTypeGroupCode($vehTypeGroupCode:InputVehTypeGroupCodeRemove!) {
	vehTypeGroupCodeRemove(vehTypeGroupCode: $vehTypeGroupCode) {
		ok
		message
	}
}
`;
